<template>
    <ValidationObserver
        v-slot="{ invalid }"
        ref="observer"
        tag="form"
        @keydown.prevent.enter="submit"
    >
        <Portal to="header-actions">
            <AntButton
                type="primary"
                :disabled="invalid || !validationObserverReady"
                :loading="loading"
                @click="submit"
            >
                {{ $t('save') }}
            </AntButton>
        </Portal>
        <TextFieldWithValidation
            v-model="customer.name"
            type="text"
            auto-focus
            :label="$t('name')"
            name="name"
            autocomplete="name"
            placeholder="Jan"
            required
            rules="required"
        />
        <TextFieldWithValidation
            v-model="customer.contactPerson"
            type="text"
            :label="$t('contactPerson')"
            name="contactPerson"
            placeholder="Jan"
            required
            rules="required"
        />
        <TextFieldWithValidation
            v-model="customer.email"
            type="text"
            :label="$t('email')"
            name="email"
            placeholder="jan@example.com"
            required
            rules="required|email"
        />
        <PasswordFieldWithValidation
            v-model="customer.password"
            type="text"
            :tooltip="$t('passwordHelp')"
            :label="$t('password')"
            name="password"
            :required="isCreate"
            :rules="isCreate ? 'required' : null"
        />
    </ValidationObserver>
</template>

<script>
import PasswordFieldWithValidation from '@/components/forms/elements/withValidation/PasswordFieldWithValidation.vue';
import validationObserverMixin from '@/mixins/validationObserver';
import TextFieldWithValidation from '@/components/forms/elements/withValidation/TextFieldWithValidation.vue';
import { Button } from 'ant-design-vue';

export default {
    name: 'CustomerForm',
    components: {
        AntButton: Button,
        TextFieldWithValidation,
        PasswordFieldWithValidation,
    },
    mixins: [validationObserverMixin],
    props: {
        value: {
            type: Object,
            default() {
                return {};
            },
        },
        errors: {
            type: Object,
            default() {
                return {};
            },
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            customer: {
                name: '',
                contactPerson: '',
                email: '',
                password: '',
            },
        };
    },
    computed: {
        isCreate() {
            return Object.keys(this.value).length === 0;
        },
    },
    watch: {
        errors() {
            this.$refs.observer.setErrors(this.errors);
        },
        value: {
            immediate: true,
            handler() {
                this.customer = { ...this.customer, ...this.value };
            },
        },
    },
    methods: {
        async submit() {
            const isValid = await this.$refs.observer.validate();

            if (!isValid) {
                return;
            }

            this.$emit('submit', this.customer);
        },
    },
};
</script>
